export const TOC_SIDEBAR = {
    TOC_SETTINGS_TITLE: {
        key: 'TOC_SIDEBAR_TITLE',
        value: 'Table of contents settings'
    },
    TITLE: {
        key: 'TITLE',
        value: 'TITLE'
    },
    SECTION: {
        key: 'SECTION',
        value: 'SECTION'
    },
    SUB_SECTION: {
        key: 'SUB_SECTION',
        value: 'SUB SECTION'
    },
    DISPLAY_TEXT: {
        key: 'DISPLAY_TEXT',
        value: 'Display text'
    },
    DISPLAY_TEXT_PLACEHOLDER: {
        key: 'DISPLAY_TEXT_PLACEHOLDER',
        value: 'Text to be displayed in table of contents'
    },
    INCLUDE_IN_TOC: {
        key: 'INCLUDE_IN_TOC',
        value: 'Include in TOC'
    }
};
